import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill } from "remotion";
import { loadFont as loadDev } from "@remotion/google-fonts/NotoSansDevanagari";
import type { YearStampData } from "./types";

const { fontFamily: devFont } = loadDev("normal", { weights: ["400", "700"], subsets: ["devanagari", "latin"] });

const GOLD = "#D4A853";

export const YearStamp: React.FC<{ data: YearStampData; durationInFrames: number }> = ({ data, durationInFrames }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const fadeIn = interpolate(frame, [0, Math.round(0.35 * fps)], [0, 1], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
    easing: Easing.bezier(0.16, 1, 0.3, 1),
  });
  const slideX = interpolate(frame, [0, Math.round(0.35 * fps)], [-60, 0], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
    easing: Easing.bezier(0.16, 1, 0.3, 1),
  });
  const fadeOut = interpolate(frame, [durationInFrames - Math.round(0.5 * fps), durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      <div style={{
        position: "absolute", top: 25, left: 0,
        display: "inline-block",
        opacity: fadeIn * fadeOut,
        transform: `translateX(${slideX}px)`,
      }}>
        {/* gradient background — behind text */}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(to right, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.75) 60%, rgba(0,0,0,0.3) 85%, transparent 100%)",
          zIndex: 0,
        }} />
        {/* gold left border */}
        <div style={{
          position: "absolute", left: 0, top: 0, bottom: 0,
          width: 3, background: GOLD, zIndex: 2,
        }} />
        {/* text — above gradient */}
        <div style={{ position: "relative", zIndex: 1, padding: "12px 60px 12px 28px" }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", lineHeight: 1 }}>
            <span style={{ color: GOLD, fontSize: 22, fontWeight: 800, fontFamily: devFont }}>
              {data.display}
            </span>
            {data.display_latin && <>
              <span style={{ color: "rgba(212,168,83,0.5)", fontFamily: devFont, fontSize: 22 }}>|</span>
              <span style={{ color: GOLD, fontSize: 22, fontWeight: 800, fontFamily: devFont }}>
                {data.display_latin}
              </span>
            </>}
          </div>
          {data.context && (
            <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 11, fontWeight: 400, fontFamily: devFont, marginTop: 6, lineHeight: 1.4 }}>
              {data.context}
            </div>
          )}
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
